import { useCallback, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { normalizeLibrarySort } from './librarySort';

export const LIBRARY_SESSION_PREFIX = 'promptcrew:library:';

export default function useLibrarySessionState(view, field, initialValue) {
  const { user } = useAuth();
  const key = `${LIBRARY_SESSION_PREFIX}${user?.id || 'anonymous'}:${view}:${field}`;
  const read = () => {
    try {
      const saved = sessionStorage.getItem(key);
      if (saved !== null) return JSON.parse(saved);
    } catch { /* Storage is optional. */ }
    return typeof initialValue === 'function' ? initialValue() : initialValue;
  };
  const [stored, setState] = useState(() => ({ key, value: read() }));
  const state = stored.key === key ? stored.value : read();
  const update = useCallback((value) => {
    setState((storedPrevious) => {
      const previous = storedPrevious.key === key ? storedPrevious.value : read();
      const next = typeof value === 'function' ? value(previous) : value;
      try { sessionStorage.setItem(key, JSON.stringify(next)); } catch { /* Storage is optional. */ }
      return { key, value: next };
    });
  // The storage key defines this preference; defaults are only used before a value is saved.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return [field === 'sort' && ['knowledge', 'projects'].includes(view) ? normalizeLibrarySort(state) : state, update];
}
